import { render, staticRenderFns } from "./ExternalProjects.vue?vue&type=template&id=0169b46e&"
import script from "./ExternalProjects.vue?vue&type=script&lang=js&"
export * from "./ExternalProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports